import { SVGProps } from "react";

const Delete2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.33398 9.66675V14.6667"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.666 9.66675V14.6667"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33398 6.33325H16.6673"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 6.33325H10H15V14.9999C15 16.6568 13.6569 17.9999 12 17.9999H8C6.34315 17.9999 5 16.6568 5 14.9999V6.33325Z"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 5C7.5 3.89543 8.39543 3 9.5 3H10.5C11.6046 3 12.5 3.89543 12.5 5V6.33333H7.5V5Z"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Delete2;
